export default {"src":"/_next/static/media/topsport.d40e7a1f.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};